<div *ngIf="!hideInfo">
  <small class="timeline-panel-small">(<abbr title="máximo">max.</abbr> de 10 imagens por item)</small>
</div>

<div class="bg-gray">
  <ul class="pessoa">
    <li *ngFor="let doctoPessoa of documentosPorPessoa | keyvalue">
      <div class="pessoa-item" *ngIf="doctoPessoa.value?.length > 0">
        <h2 *ngIf="doctoPessoa.key===0">Cliente</h2>

        <h2 *ngIf="doctoPessoa.key!==0">Avalista {{ doctoPessoa.key }}</h2>
        {{ doctoPessoa.key!==0 ? getCpfAvalista(doctoPessoa.key) : '' }}
      </div>
      <ul class="required-documents" *ngIf="doctoPessoa.value?.length > 0">
        <li class="required-documents-item row" *ngFor="let docto of doctoPessoa.value; index as i">
          <app-upload-documentation-item-multiavalistas
            *ngIf="docto.idPendencia !== Documentation.Report"
            (fileChange)="handleFileChange($event, doctoPessoa.key, i)"
            [files]="getNormalizedFileList(doctoPessoa.key, i)"
            [filesDocuments]="normalizedFileList"
            [document]="docto"
            [documentPersonIndex]="doctoPessoa.key"
            [documentIndex]="i"
            [removeFileCallback]="removeFile"
            [removeAllFilesCallback]="removeAllFiles"
            [acceptFiles]="acceptFiles"
          ></app-upload-documentation-item-multiavalistas>

          <app-report-documentation-item
            *ngIf="docto.idPendencia === Documentation.Report"
            [document]="docto"
            [proposalId]="idFicha"
            (changeReport)="handleChangeReport($event)"
          ></app-report-documentation-item>
        </li>
      </ul>
    </li>
  </ul>
  <section *ngIf="hasAllWarrantyPicturesDocument()">
    <p class="photos-title">Insira imagens do veículo:</p>

    <ul class="photos list-unstyled" style="height: 150px">
      <li>
        <app-upload-foto-garantia (fileChange)="fileGarantiaChange($event, 0)" (errorSize)="isSizeLimit = true"></app-upload-foto-garantia>
      </li>

      <li>
        <app-upload-foto-garantia (fileChange)="fileGarantiaChange($event, 1)" (errorSize)="isSizeLimit = true"></app-upload-foto-garantia>
      </li>

      <li>
        <app-upload-foto-garantia (fileChange)="fileGarantiaChange($event, 2)" (errorSize)="isSizeLimit = true"></app-upload-foto-garantia>
      </li>
    </ul>
  </section>

  <div>
    <div *ngIf="isDocsObrigatorio" class="alert alert-danger alert-dismissable">
      <strong>Anexar todos os documentos solicitados antes do envio</strong>
    </div>

    <div *ngIf="isSizeLimit" class="alert alert-danger alert-dismissable">
      <strong>Tamanho do arquivo não permitido - Limite: 10 Mb</strong>
    </div>

    <div *ngIf="!hideInfo && mensagem" class="alert alert-info alert-dismissable">
      <span class="martinT10" *ngIf="isEnviandoDocumento">
        <em class="fa fa-spinner fa-pulse" aria-hidden="true"></em>
      </span>

      <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>

      <strong>{{ mensagem }}</strong>
    </div>
  </div>

  <button *ngIf="!isOrigemSos && !hideSendButton" class="btn btn-send send-doc martinT10" [ngClass]="{ 'enabled': validaEnvio() }" (click)="sendDocuments()">{{ buttonLabel || 'Enviar Documentos' }}</button>

  <ng-content></ng-content>
</div>
